export default __webpack_public_path__ + "static/media/mixing.55eb3ba7.svg";